import { AxiosRequestCustomConfig } from '@/composables/useFetch';
import { config as conf } from '@/config';
import { JWT } from '@/model/authen';
import { getToken } from '@/util/localStorage';
import axios, { AxiosError, HttpStatusCode } from 'axios';

const instance = axios.create({
	baseURL: conf.host,
	timeout: 1000 * 60 * 1, // 1 minute
	headers: {
		'Content-Type': 'application/json'
	}
});

instance.interceptors.response.use(
	(response) => response,
	async (error: AxiosError) => {
		const config = { ...error.config } as AxiosRequestCustomConfig;
		if (error.code === 'ERR_NETWORK' && !config._isRetry && conf.host !== conf.backupHost) {
			config._isRetry = true;
			config.baseURL = conf.backupHost;
			return instance.request(config);
		}
		return Promise.reject(error);
	}
);

export { instance };

export async function signin(idToken: string) {
	const res = await instance.request<JWT>({
		url: '/authen/signin',
		method: 'POST',
		data: { idToken },
		headers: {
			'X-API-Key': conf.apiKey
		}
	});
	if (res.status === 200) {
		return res.data;
	}
	return '';
}

export async function refreshJWT(refreshToken: string) {
	const res = await instance.request<JWT>({
		url: '/authen/refresh',
		method: 'POST',
		data: { refreshToken },
		headers: {
			'X-API-Key': conf.apiKey
		}
	});
	if (res.status === HttpStatusCode.Ok) {
		return res.data;
	}
	return '';
}

export async function signout() {
	return await instance.request({
		url: '/authen/signout',
		method: 'POST',
		headers: {
			Authorization: `Bearer ${getToken()?.accessToken}`
		}
	});
}
